export const OPEN_DELAY = 50;
export const CLOSE_DELAY = 50;
export const NAVIGATION_MENU_TRIGGER_IDENTIFIER = 'data-base-ui-navigation-menu-trigger';
